import useUserLocation from "@lululemon/ecom-common/src/components/bopis/hooks/use-user-location";
import useSelectedStore from "@lululemon/ecom-common/src/components/bopis/hooks/use-selected-store";
import useNearbyBopisStores from "@lululemon/ecom-common/src/components/bopis/hooks/use-nearby-bopis-stores";
const useBopisLocation = ({ activeSku, shouldFetchInventory }) => {
  const {
    getUserAddress,
    getUserAddressError,
    getUserCityState,
    hasCookieError,
    isLoadingUserAddress,
    setUserLocation,
    setGetUserAddressError,
    userLocation,
  } = useUserLocation();
  const { selectedStore, setSelectedStore } = useSelectedStore();
  const {
    isLoadingUserSearchQuery,
    nearbyBopisStores,
    nearbyStoresWithInventoryButNoBopis,
    getAddressFromSearchQuery,
    userSearchedLocation,
    userSearchedQuery,
    setUserSearchedLocation,
    searchQueryError,
    setSearchQueryError,
  } = useNearbyBopisStores({ activeSku, shouldFetchInventory });

  const handleGetUserAddress = () => {
    if (userSearchedLocation) {
      setUserSearchedLocation(null);
    }
    if (searchQueryError) {
      setSearchQueryError(null);
    }
    getUserAddress();
  };

  const handleOnSelectStore = async (activeStoreRadioBtn) => {
    if (userSearchedLocation) {
      setUserLocation(userSearchedLocation);
    }
    setSelectedStore({
      ...activeStoreRadioBtn,
    });
    localStorage.setItem("selectedStoreName", activeStoreRadioBtn.name);
    localStorage.setItem("selectedStoreId", activeStoreRadioBtn.id);
    localStorage.setItem(
      "selectedStoreAddress",
      JSON.stringify(activeStoreRadioBtn.address)
    );
  };

  return {
    getUserAddress,
    getUserAddressError,
    getUserCityState,
    handleGetUserAddress,
    handleOnSelectStore,
    hasCookieError,
    isLoadingUserAddress,
    setUserLocation,
    setGetUserAddressError,
    userLocation,
    selectedStore,
    setSelectedStore,
    isLoadingUserSearchQuery,
    nearbyBopisStores,
    nearbyStoresWithInventoryButNoBopis,
    getAddressFromSearchQuery,
    userSearchedLocation,
    userSearchedQuery,
    setUserSearchedLocation,
    searchQueryError,
    setSearchQueryError,
  };
};
export default useBopisLocation;
